import { useMemo } from "react";
import { languageConstants } from "main/src/js/constants/internationalize";
import { IntlLoader } from "main/src/translations";
import { useLanguageStore } from "../../store/language/useLanguageStore";
import { useUserPreferredLanguage } from "./useUserPreferredLanguage";

export const usePreferredLocale = (): string => {
  const selectedLanguage = useLanguageStore(state => state.language);
  const userPreferredLanguage = useUserPreferredLanguage();

  return useMemo(() => {
    let locale: string = (
      selectedLanguage ||
      userPreferredLanguage ||
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      languageConstants.DEFAULT_LOCALE
    ).toLowerCase();

    if (!IntlLoader[locale]) {
      const secondaryLocale = locale.split("-")[0];

      if (locale === secondaryLocale || !IntlLoader[secondaryLocale]) {
        locale = languageConstants.DEFAULT_LOCALE;
      } else {
        locale = secondaryLocale;
      }
    }

    return locale;
  }, [selectedLanguage, userPreferredLanguage]);
};
